import { api } from '../api/client';
import {
	API_EXPORT_ALL_JOB_URL,
	API_EXPORT_ALL_LINK_URL,
	API_EXPORT_ALL_URL,
} from '../utils';

/**
 * EXPORT EVERYTHING (KPR-742; keepr-api docs/SCHEMA.md § Export everything):
 * every item, card definition and file the person can read in a collection,
 * as one zip keepr makes in the background and keeps for a week.
 *
 *   POST /api/collections/{id}/export-all   { history?, subCollections? }
 *        202 a new job · 200 the person's running one · 409 export_all_running
 *        (another sign-in of theirs is making one) · 429 export_all_limit
 *   GET  /api/collections/{id}/export-all          their recent jobs, newest first
 *   GET  /api/collections/{id}/export-all/{jobId}   one job
 *   POST /api/collections/{id}/export-all/{jobId}/link   { url, expiresAt }
 *
 * A job: { _id, status: queued|running|succeeded|failed|expired, options,
 * progress, result, size, expiresAt, error: { code, message } | null, … }.
 *
 * The zip is never fetched through axios: it can be gigabytes, and a blob
 * would hold all of it in the page. The browser NAVIGATES to a fifteen-minute
 * link the API mints for the person (`downloadExportAll`), so the download is
 * the browser's own — on a phone too.
 */

export async function startExportAll( collectionId, { history = false, subCollections = false } = {} ) {
	const body = {};
	if ( history ) body.history = true;
	if ( subCollections ) body.subCollections = true;
	const { data } = await api.post( API_EXPORT_ALL_URL( collectionId ), body );
	return data;
}

export async function listExportAll( collectionId ) {
	const { data } = await api.get( API_EXPORT_ALL_URL( collectionId ) );
	return Array.isArray( data ) ? data : [];
}

export async function getExportAll( collectionId, jobId ) {
	const { data } = await api.get( API_EXPORT_ALL_JOB_URL( collectionId, jobId ) );
	return data;
}

export async function linkExportAll( collectionId, jobId ) {
	const { data } = await api.post( API_EXPORT_ALL_LINK_URL( collectionId, jobId ) );
	return data;
}

/**
 * Mints the link and sends the browser to it. `assign` is the navigation
 * (window.location.assign by default; the tests hand in their own).
 */
export async function downloadExportAll( collectionId, jobId, { assign = url => window.location.assign( url ) } = {} ) {
	const { url } = await linkExportAll( collectionId, jobId );
	if ( ! url ) throw new Error( 'No download link came back.' );
	assign( url );
	return url;
}
